module.exports = __webpack_public_path__ + "static/media/empty_welcome.985d7508.png";